import { render } from "./corpghdw.vue?vue&type=template&id=bc17661c&scoped=true"
import script from "./corpghdw.vue?vue&type=script&lang=js"
export * from "./corpghdw.vue?vue&type=script&lang=js"

import "./corpghdw.vue?vue&type=style&index=0&id=bc17661c&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/root/qzf/src/invoice-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc17661c"]])

export default __exports__